import { h, Component } from "preact";
import EventList from "./EventList";
import EventListFilter from "./filters/EventListFilter";
import actions from "../actions";
import { connectWithTranslations } from "../../common/helpers/translationsHelpers";
import Modal from "../../common/components/Modal";
import ModalLegend from "./modal/ModalLegend";
import { mustOneSignalInit } from "../../calendar-common/helpers/oneSignalHelper";
import BlockedPopup from "./modal/BlockedPopup";
import { enabledCalendarNotifications } from "../../calendar-common/helpers/calendar";
import {
    persistSettings,
    getSettingsWithNoFilter,
} from "../../calendar-common/helpers/settingsHelper";
import EventNotifyModal from "./modal/EventNotifyModal";

class CalendarContainer extends Component {
    constructor(props) {
        super(props);

        this.trackScrolling = this.trackScrolling.bind(this);
        this.isBottom = this.isBottom.bind(this);
        this.getNotificationSetting = this.getNotificationSetting.bind(this);
    }

    componentWillMount() {
        this.props.initSettingsListener();
        this.props.initTimezones();
        this.props.fetchLocalizations();
        this.props.subscribeToCalendar();
        this.props.initEventNotifications();
    }

    getNotificationSetting() {
        let settings = getSettingsWithNoFilter();
        if(settings)
            return settings.eventNotifyShown;

        return null;
    }

    initNotificationSetting() {
        let settings = getSettingsWithNoFilter();

        if (settings && !settings.hasOwnProperty("eventNotifyShown"))
            persistSettings({
                eventNotifyShown: true,
            });
    }

    componentDidMount() {
        fxsWidgets.load("calendar-settings", true);
        this.initNotificationSetting();
    }

    isBottom(element) {
        return (
            Math.trunc(element.scrollHeight - element.scrollTop) ===
            element.clientHeight
        );
    }

    trackScrolling() {
        const wrappedElement = document.getElementById(
            "economic-calendar-events"
        );
        if (
            this.isBottom(wrappedElement) &&
            wrappedElement.classList.contains("fxs_c_ecocal_data_shadow")
        ) {
            wrappedElement.classList.remove("fxs_c_ecocal_data_shadow");
        } else if (
            !this.isBottom(wrappedElement) &&
            !wrappedElement.classList.contains("fxs_c_ecocal_data_shadow")
        ) {
            wrappedElement.classList.add("fxs_c_ecocal_data_shadow");
        }
    }

    render({
        translate,
        showConnectionError,
        hideModalConnectionError,
        showModalLegend,
        showBlockedPopup,
        config,
        eventNotifyShown,
        showEventNotifyModal,
    }) {
        return (
            <div className="fxs_widget fxs_c_calendar_wrapper">
                {eventNotifyShown && this.getNotificationSetting() && (
                    <EventNotifyModal
                        showEventNotifyModal={showEventNotifyModal}
                    />
                )}
                {mustOneSignalInit(config) && (
                    <script src={config.oneSignalUrl} async=""></script>
                )}
                {showBlockedPopup && <BlockedPopup />}
                <div
                    fxs-widget
                    name="calendar-settings"
                    show="false"
                    open-close-event-name={config.settingsOpenCloseEventName}
                    subscription-changed-event-name={
                        config.subscriptionChangedEventName
                    }
                    has-notifications={enabledCalendarNotifications(config)}
                    tracking={config.tracking}
                    premium-url={config.premiumUrl}
                    notifications-helper={config.notificationsHelper}
                    culture={this.props.config.culture}
                ></div>
                <div
                    class="fxs_widget fxs_c_ecocal"
                    dir={`${
                        translate("IsRightToLeftOriented") ? "rtl" : "auto"
                    }`}
                >
                    {showModalLegend && <ModalLegend />}
                    <EventListFilter />
                    <div
                        id="economic-calendar-events"
                        onScroll={this.trackScrolling}
                        class="fxs_c_ecocal_data fxs_c_ecocal_data_shadow"
                    >
                        {showConnectionError && (
                            <Modal
                                handleClose={hideModalConnectionError}
                                sectionClassName="fxs_c_modal-main"
                            >
                                {translate("ErrorConnectMessage")}
                            </Modal>
                        )}
                        <EventList />
                    </div>
                </div>
            </div>
        );
    }
}

export default connectWithTranslations(
    "config,showConnectionError,showModalLegend,showBlockedPopup, eventNotifyShown",
    actions
)(CalendarContainer);
